

























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { USAGE_STAT_FEATURES } from '../system/usage-stats'
import { download } from '@/helpers/download'
import { combineArtistTitle } from '../helpers/track'

@Component({})
export default class CopyTextModal extends Vue {
  showNumbers: boolean = true
  open: boolean = false

  @Prop({
    default: () => []
  })
  tracks: Track[]

  @Prop()
  text: string

  @Prop({
    default: 'Copy to clipboard'
  })
  title: string

  @Prop({
    default: false
  })
  hideNumberCheckbox: boolean

  @Prop({
    default: `download.txt`
  })
  filename: string

  openModal() {
    this.$emit('open')

    this.open = true
  }

  copyToClipboard() {
    const el = document.createElement('textarea')
    el.value = this.tracksText
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)

    this.$buefy.notification.open('Copied to clipboard')

    this.open = false

    window.addUsageStat(USAGE_STAT_FEATURES.SocialShare, 'copy')
  }

  save() {
    download(this.tracksText, this.filename)
  }

  get tracksText(): string {
    if (this.text) return this.text

    let s: string = ''

    for (let i = 0; i < this.tracks.length; i++) {
      if (!this.hideNumberCheckbox && this.showNumbers) s += `${i + 1}. `

      s += combineArtistTitle(this.tracks[i].artist, this.tracks[i].title)

      s += `\n`
    }

    return s.trim()
  }
}
